import React from 'react';

export default class Clickable extends React.PureComponent {
    render() {
        return <div style={{
            position: 'absolute',
            left: this.props.x * this.props.width - 30,
            top: this.props.y * this.props.height - 30,
            width: 60,
            height: 60,
        }} onClick={this.props.onClick}></div>;
    }
}
